import common from "../reisinger/common.json";

const sources = {
  common,
};

export default sources;
